'use client';

import Link from 'next/link';
import Logo from '@referralexchange/rea-ui-react/src/svgs/rea-logo';
import { useAnalytics } from '~/contexts/AnalyticsContext.tsx';

export default function LogoLink() {
  const { reaa } = useAnalytics();
  return (
    <Link href="/" onClick={() => reaa('signin_event', 'logo_click', {})}>
      <Logo />
    </Link>
  );
}
